import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Toggle from 'react-toggle';
import 'react-toggle/style.css'; // ייבוא סגנונות

/* === עיצובי צבעים ורוחב/גובה =============================== */
const variants = {
  swtOutlineGray200_5: {
    offColor: "#CE0000", // צבע כשהסוויץ' כבוי
    onColor: "#CE0000",  // החליפי כאן את הצבע הירוק הקיים לצבע החדש שאת רוצה
    offHandleColor: "#CE0000",
    onHandleColor: "#CE0000", // ידית לבנה
  },
}
const sizes = {
  xs: { width: 36, height: 18 },
  sm: { width: 64, height: 32 },
};
/* =========================================================== */

/**
 * Switch “דק” – רכיב *controlled* בלבד
 */
export const Switch = ({
  checked = false,
  value,
  onCheckedChange,
  className,
  disabled = false,
  checkedIcon = null,
  uncheckedIcon = null,
  variant = "swtOutlineGray200_5",
  size = "xs",
}) => {
  const propChecked = typeof value === "boolean" ? value : checked;
  const [internalChecked, setInternalChecked] = useState(propChecked);
  const isControlled = typeof onCheckedChange === "function";
  const isChecked = isControlled ? propChecked : internalChecked;

  useEffect(() => {
    setInternalChecked(propChecked);
  }, [propChecked]);

  const handleChange = (e) => {
    const nextChecked = e.target.checked;

    if (!isControlled) {
      setInternalChecked(nextChecked);
    }

    onCheckedChange?.(nextChecked);
  };

  return (
  <div className={className}>
    <Toggle
      checked={isChecked}
      onChange={handleChange} // ← חשוב מאוד!
      disabled={disabled}
      icons={{ checked: checkedIcon, unchecked: uncheckedIcon }}
      aria-label="switch"
      {...variants[variant]}
      style={{ width: sizes[size].width, height: sizes[size].height }}
    />
  </div>
  );
};


Switch.propTypes = {
  checked: PropTypes.bool,
  value: PropTypes.bool,
  onCheckedChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  checkedIcon: PropTypes.node,
  uncheckedIcon: PropTypes.node,
  size: PropTypes.oneOf(["sm", "xs"]),
  variant: PropTypes.oneOf(["swtOutlineGray200_5"]),
};
